import React, { useEffect } from "react";
import { ReactComponent as AddUserIcon } from "../../../assets/icons/management/adduser.svg";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddCategoryForm from "../forms/AddCategoryForm/AddCategoryForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddCategoryModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати категорію товару"
          subTitle="Додайте нову категорію. Виберіть фото та заповніть необхідну інформацію."
          isLittleMargin={true}
        >
          <AddUserIcon />
        </ModalTitle>
        <AddCategoryForm onClose={props.onClose} onApply={onApply} />
      </div>
    </DefaultModal>
  );
};

export default AddCategoryModal;
